import { GROUP_ACCOUNTS_SHOW_MESSAGE, GROUP_ACCOUNTS_LOAD, GROUP_ACCOUNTS_RESET_REDUCER } from '../types'

const initialState = {
	groupId: null,
	showMessage: true,
	accounts: {}
}

export default function reducer(state = initialState, action) {
  	switch (action.type) {
		case GROUP_ACCOUNTS_SHOW_MESSAGE:
         return { 
				...state,
				showMessage: action.payload
			}
		case GROUP_ACCOUNTS_LOAD:
         return { 
				...state,
				accounts: action.payload.accounts
			}
		case GROUP_ACCOUNTS_RESET_REDUCER:
			return { 
				...state,
	         groupId: action.payload,
	         accounts: {}
			}
		default:
			return state
	}
}


